// extracted by mini-css-extract-plugin
export default {"container":"ShapeBadge_container__cbqHQ","icon":"ShapeBadge_icon__jzD-x","label":"ShapeBadge_label__z6QZp"};